import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    token: '',
    orgID: '',
    startTime: '',
    stopTime: '',
    bizChannel: '',
    userInfo: {}
  },
  mutations: {
    mutToken (state, data) { state.token = data;console.log(state.token) },
    mutOrgID (state, data) { state.orgID = data },
    mutStartTime (state, data) { state.startTime = data },
    mutStopTime (state, data) { state.stopTime = data },
    mutBizChannel (state, data) { state.bizChannel = data },
    mutUserInfo (state, data) { state.userInfo = data }
  },
  actions: {
    addToken (context,data) { context.commit('mutToken',data) },
    addOrgID (context,data) { context.commit('mutOrgID',data) },
    addStartTime (context,data) { context.commit('mutStartTime',data) },
    addStopTime (context,data) { context.commit('mutStopTime',data) },
    addBizChannel (context,data) { context.commit('mutBizChannel',data) }
  },
  getters: {
    rtoken (state) { return state.token },
    rorgID (state) { return state.orgID },
    rstartTime (state) { return state.startTime },
    rstopTime (state) { return state.stopTime },
    rbizChannel (state) { return state.bizChannel }
  }
});

export default store;






















